import * as React from "react";
const SvgPlus = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 13, height: 14, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M12.41 5.57v2.75H.71V5.57zM8.05.87v12.42H5.1V.87z" }));
export default SvgPlus;
